<section class="bread-block">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['']">Головна</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/portfolio']">Портфоліо</a></li>
        <li class="breadcrumb-item">Мережа продуктових супермаркетів «Бімаркет»</li>
      </ol>
    </nav>
  </div>
</section>

<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">МЕРЕЖА ПРОДУКТОВИХ СУПЕРМАРКЕТІВ «БІМАРКЕТ»</div>
  </div>
</section>

<section class="slider">
  <div class="container">
    <div class="portfolio-owl owl-carousel owl-theme">
      <div class="slider-item">
        <img src="../../../../assets/images/bimarket.jpeg" alt="Сеть продуктовых супермаркетов «Бимаркет»"
             class="img-fluid">
      </div>
    </div>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <p>Мережа продуктових супермаркетів «Бімаркет» (м. Київ)</p>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">Проведені роботи</div>
    <ol>
      <li>Монтаж побутових та промислових систем кондиціювання на базі обладнання Fuji Electric (Малайзія) та Ostberg (Швеція)</li>
      <li>Монтаж побутових та промислових систем вентиляції на базі обладнання Ostberg (Швеція)</li>
    </ol>
  </div>
</section>

<app-our-advantages></app-our-advantages>
<app-our-clients-small></app-our-clients-small>
<app-feedback></app-feedback>
<app-map></app-map>
